import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '../styles/enterKeyModal.scss';
import ButtonComponent from './ButtonComponent';
import Popup from './Popup';
import { t } from 'i18next';
import { getImageSrc } from '../helper/imageBlobCache';
import { formatShareCode } from '../helper/shareCode';
import { copyTextToClipboard } from '../helper/clipboardHelper';
var ViewCodeModal = function (_a) {
    var showModal = _a.showModal, setShowModal = _a.setShowModal, code = _a.code;
    // Format code with dash: "4JGBQT3X" → "4JGB-QT3X"
    var formattedCode = formatShareCode(code);
    return (_jsx(Popup, { isOpen: showModal, onClose: function () { return setShowModal(false); }, children: _jsxs("div", { className: "modalContainer viewCodeModal", children: [_jsx("div", { className: "title", children: t('text.code') }), _jsx("hr", { className: "popupHr", "aria-hidden": "true" }), _jsx("div", { className: "inputBox", style: { userSelect: 'all', cursor: 'text' }, children: formattedCode }), _jsx(ButtonComponent, { type: "textType1", text: t('text.ok'), defaultCSS: "openBtn", normalCSS: "normalBtn", clickHandler: function () {
                        void copyTextToClipboard(code);
                        setShowModal(false);
                    }, ariaLabel: "text.ok" }), _jsx("div", { className: "footerModal", children: _jsx("img", { src: getImageSrc("./assets/images/popupColorPatch.svg"), tabIndex: -1, alt: "" }) })] }) }));
};
export default ViewCodeModal;
